"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeVisibleInViewport = exports.getThreadWillOverflowViewport = exports.getPositionsForThreadWhenInViewport = exports.getPositionsForThreadWhenOverflowingViewport = void 0;
var ViewportPadding = 24;
var MarkerPadding = 10;
var scroll_into_view_if_needed_1 = __importDefault(require("scroll-into-view-if-needed"));
var getPositionsForThreadWhenInViewport = function (containerPosition, markerPosition) {
    var topPosition = markerPosition.top - containerPosition.top;
    var leftPosition = markerPosition.right - containerPosition.left;
    return {
        topPosition: topPosition,
        leftPosition: leftPosition,
    };
};
exports.getPositionsForThreadWhenInViewport = getPositionsForThreadWhenInViewport;
var getPositionsForThreadWhenOverflowingViewport = function (markerPosition, containerPosition, browserViewport) {
    var topPosition = markerPosition.bottom - containerPosition.top + MarkerPadding;
    var rightPosition = containerPosition.right - browserViewport + ViewportPadding;
    return {
        rightPosition: rightPosition,
        topPosition: topPosition,
        leftPosition: "",
    };
};
exports.getPositionsForThreadWhenOverflowingViewport = getPositionsForThreadWhenOverflowingViewport;
var getThreadWillOverflowViewport = function (markerPosition, threadRectangle, viewportWidth) {
    var rightPositionOfThread = markerPosition.right + threadRectangle.width;
    return rightPositionOfThread > viewportWidth;
};
exports.getThreadWillOverflowViewport = getThreadWillOverflowViewport;
var makeVisibleInViewport = function (element) {
    (0, scroll_into_view_if_needed_1.default)(element, {
        scrollMode: "if-needed",
        behavior: "smooth",
        block: "center",
    });
};
exports.makeVisibleInViewport = makeVisibleInViewport;
